import { render, staticRenderFns } from "./PalmTreeWithMan.vue?vue&type=template&id=78e519d2&scoped=true&"
import script from "./PalmTreeWithMan.vue?vue&type=script&lang=js&"
export * from "./PalmTreeWithMan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e519d2",
  null
  
)

export default component.exports